export default {
    baseStyle: () => ({
        container: {
            pl: 4,
            pr: 4
        },
        accTitle: {
            textStyle: 'labelSm',
            flex: '1',
            textAlign: 'left'
        },
        accArrow: {
            width: '15px',
            height: '15px'
        },
        checkboxContainer: {
            display: 'flex',
            minHeight: '24px'
        },
        inputLabel: {
            textStyle: 'bodyXsRegular',
            mb: 1
        },
        nrContainer: {
            pt: 6,
            pb: 6
        },
        nrText: {
            textStyle: 'labelXs'
        },
        nrDescription: {
            textStyle: 'bodyXsRegular'
        },
        sbAccItem: {
            borderTop: 'none',
            borderBottom: '1px solid webTheme.strokeTertiary',
            mx: 4
        },
        sbSelectedLabel: {
            textStyle: 'bodySmRegular',
            color: 'webTypo.textSecondary'
        },
        sortingRadioGroup: {
            paddingLeft: {base: 1, lg: 0}
        }
    })
}
